import {Box, Typography} from "@mui/joy";
import {CrudTable} from "@/components/CrudTable.jsx";
import {capitalizeFirstLetter} from "@/utils/strings.js";
import {useDeleteInvitationMutation, useGetInvitationsQuery, useResendInvitationMutation} from "@/features/users/api.js";
import {useCrudHouseholdMutation} from "@/hooks/useCrudHouseholdMutation.js";
import {useParams} from "react-router-dom";
import BlockRoundedIcon from "@mui/icons-material/BlockRounded";
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import {ConfirmAction} from "@/components/ConfirmAction.jsx";

export function Invitations() {
  const { householdId } = useParams();
  const useQuery = () => useGetInvitationsQuery({ householdId });
  const useDelete = useCrudHouseholdMutation(householdId, useDeleteInvitationMutation);
  const useResend = useCrudHouseholdMutation(householdId, useResendInvitationMutation);

  const { data } = useQuery();

  const options = {
    names: {
      singular: 'invitation',
      plural: 'invitations',
    },

    columns: [
      { label: 'Email', getter: (row) => row.email},
      { label: 'Role', getter: (row) => capitalizeFirstLetter(row.role) },
    ],

    options: {
      searchable: false,
      header: false,
      customHeader: <Box sx={{ pt: 0.75, pb: 1 }}>

        <Typography level="body-sm" sx={{ fontWeight: 400 }}>An email with the invitation link has been sent to these users and hasn&apos;t been accepted yet</Typography>
      </Box>
    },

    actions: {
      noPrimary: true,
      list: useQuery,
      get: ':id',
      extra: [{
        type: 'resend',
        render: (row) => <ConfirmAction key="resend" id={row.id} useAction={useResend} icon={<ReplayOutlinedIcon />} texts={{
          tooltip: "Resend invitation",
          title: "Resend invitation?",
          message: `Are you sure you want to resend invitation email for ${row.email}?`,
          action: 'Resend',
          successMessage: 'Invitation email has been resent!',
        }} />,
      }, {
        type: 'delete',
        render: (row) => <ConfirmAction key="revoke" id={row.id} name={row.email} useAction={useDelete} icon={<BlockRoundedIcon />} texts={{
          tooltip: "Cancel invitation",
          title: "Cancel invitation?",
          message: `Are you sure you want to cancel invitation for ${row.email}?`,
          action: 'Revoke',
        }} actionColor="danger" />,
      }],
    },
  };

  return data?.data?.length > 0 && (
    <Box>
      <Typography level="h4" sx={{ mb: 1.5 }}>Pending Invitations</Typography>
      <CrudTable {...options} />
    </Box>
  );
}
